import styled from "styled-components";

export const BeginnersGuideInviteStyled = styled.div`
    padding: 0 16px 24px 0;
    display: flex;
    flex: 1;
    min-height: 226px;
`;

export const BeginnersGuideInviteOverlayStyled = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(156.34% 57.19% at 45.87% 100%, rgba(28, 36, 40, 0.92) 36.19%, rgba(15, 18, 20, 0.00) 100%);
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    width: 100%;
    z-index: 1300;
    transition: opacity 0.3s ease-out;
    opacity: 1;
    
    &.hidden {
        opacity: 0;
    }
`;

export const BeginnersGuideInviteAvatarStyled = styled.div`
    flex: 2;
    position: relative;
    max-width: 160px;
    :before {
        content: '';
        position: absolute;
        top: -380%;
        right: 0;
        bottom: 0;
        left: 0;
        width: 240%;
        display: block;
        height: 500%;
        pointer-events: none;
        background: radial-gradient(46.4% 27.35% at 2% 95.26%, rgba(255, 239, 98, 0.31) 22.74%, rgba(255, 239, 98, 0.00) 100%), radial-gradient(19.12% 13.21% at 28.67% 91.69%, rgba(205, 238, 111, 0.31) 22.74%, rgba(205, 238, 111, 0.00) 100%);
    }
    img {
        top: 0;
        right: 0;
        position: absolute;
        width: 172px;
        height: auto;
        transform: rotate(6.005deg);
        flex-shrink: 0;
    }
`;

export const BeginnersGuideInviteDialogStyled = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    flex: 3;
    max-width: 300px;
`;

export const BeginnersGuideInviteMessageStyled = styled.div`
    padding: 8px 12px;
    border-radius: 16px 16px 16px 4px;
    background: var(--gradient-primary);
    color: var(--color-label-neutral-primary-black);
`;

export const BeginnersGuideInviteButtonsStyled = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;
